module.exports = __webpack_public_path__ + "static/img/wfyy.3a86dc3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/wfyy.png
// module id = rOJv
// module chunks = 0